import { ReloadOutlined } from '@ant-design/icons';
import { Button, Flex, Table } from 'antd';

import { PREFIX } from '@app/constants';

import {
  MedicalCardRegistryFilters,
  MedicalDocumentViewModal,
} from '../components';
import {
  useMedicalCardRegistry,
  useMedicalCardRegistryEffects,
} from '../hooks';
import '@app/pages/MedicalCard/MedicalCardRegistry/styles/MedicalCardRegistry.desktop.scss';

export const MedicalCardRegistry = () => {
  const {
    filtersData,
    isFiltersLoading,
    isSearchLoading,
    tableData,
    totalRows,
    setTableData,
    setTotalRows,
  } = useMedicalCardRegistryEffects();
  const {
    columns,
    selectedStatuses,
    setSelectedStatuses,
    selectedDoctors,
    setSelectedDoctors,
    mapMedicalDocumentToTable,
    pageNumber,
    rowsPerPage,
    handleTableChange,
    submitFormHandler,
    handleReset,
    isSendToMedFlexLoading,
    viewDocumentId,
    closeViewDocument,
    handleRefreshStatuses,
    isUpdatingStatuses,
  } = useMedicalCardRegistry({ tableData, setTableData, setTotalRows });

  return (
    <div className={`${PREFIX}medical-card-registry`}>
      <MedicalCardRegistryFilters
        filtersData={filtersData}
        isFiltersLoading={isFiltersLoading}
        selectedStatuses={selectedStatuses}
        setSelectedStatuses={setSelectedStatuses}
        selectedDoctors={selectedDoctors}
        setSelectedDoctors={setSelectedDoctors}
        submitFormHandler={submitFormHandler}
        handleReset={handleReset}
      />
      <Flex justify="flex-end" className="medical-card-registry__actions">
        <Button
          icon={<ReloadOutlined />}
          onClick={handleRefreshStatuses}
          loading={isUpdatingStatuses}
        >
          Обновить статусы
        </Button>
      </Flex>
      <Table
        columns={columns}
        dataSource={tableData.map(mapMedicalDocumentToTable) ?? []}
        loading={isSearchLoading || isSendToMedFlexLoading}
        rowKey="Id"
        pagination={{
          position: ['bottomLeft'],
          current: pageNumber,
          pageSize: rowsPerPage,
          total: totalRows,
          showSizeChanger: true,
          showTotal: (total, range) =>
            `Показаны ${range[0]}-${range[1]} из ${total}`,
          onChange: handleTableChange,
        }}
      />

      <MedicalDocumentViewModal
        documentId={viewDocumentId}
        onClose={closeViewDocument}
      />
    </div>
  );
};
